export const isGasSponsorshipError = (err: unknown): boolean => {
  const errorWithMessage = err as { message?: string } | undefined;

  return (
    errorWithMessage?.message?.includes(
      'userOp did not match any gas sponsoring policies'
    ) || false
  );
};
